export default __webpack_public_path__ + "static/ozonme-b7e3ffdb18ea685da9fe35ff2080fca9.png";